import { useMutation, useQueryClient } from "@tanstack/react-query";
import exploreCategoriesClient, {
  UpdateExploreCategoryPayload,
} from "../../../api/explore-categories";

type MutationVariables = UpdateExploreCategoryPayload & { id: string };

interface UseUpdateExploreCategoryMutationOptions {
  onSuccess?: (data: void, variables: MutationVariables) => void;
  onError?: (error: unknown, variables: MutationVariables) => void;
}

const useUpdateExploreCategoryMutation = (
  options?: UseUpdateExploreCategoryMutationOptions,
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["explore-categories"],
    mutationFn: (exploreCategory: MutationVariables) => {
      return exploreCategoriesClient.updateExploreCategory(
        exploreCategory.id,
        exploreCategory,
      );
    },
    onSuccess: (data, variables) => {
      options?.onSuccess?.(data, variables);
      queryClient.invalidateQueries({
        queryKey: ["explore-categories"],
      });
    },
    onError: (error, variables) => {
      options?.onError?.(error, variables);
    },
  });
};
export default useUpdateExploreCategoryMutation;
